import { dispatcher } from 'dispatcher';
import { useEffect, useCallback } from 'react';

export const useLegacyGameLaunchHandler = () => {
    const handleLaunchGameClick = useCallback((event) => {
        const subject = event.target.closest('.fn-launch-game');

        if (!subject) {
            return;
        }

        const data = subject.dataset;
        const code = data.gameCode || data.gamecode || data.code;
        const mode = data.demo === '1' ? 0 : 1;
        const queryString = data.queryString || '';
        const container = data.container || 'webcontent';

        if (code) {
            dispatcher.dispatch('game:launch', { code, mode, queryString, container });
        }
    }, []);

    useEffect(() => {
        document.body.addEventListener('click', handleLaunchGameClick);

        return () => {
            document.body.removeEventListener('click', handleLaunchGameClick);
        };
    }, [handleLaunchGameClick]);
};
